import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Footer.css";
import useScrollToTop from "../hooks/useScrollToTop";
import { useAuth } from "../context/AuthContext";

const Footer = () => {
  const { isLoggedIn } = useAuth();
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  useScrollToTop();

  const handleLinkClick = (path) => {
    navigate(path);
  };

  const handleAdmissionPredictorClick = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/rate-my-chances");
    }
  };

  const handleExternalLinkClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section main-section">
          <div className="footer-logo">
            <img
              src="/logo.png"
              alt="Grad4Grad Logo"
              className="footer-logo-image"
            />
            <h3>Grad4Grad</h3>
          </div>
          <p>
            Your trusted guide to study abroad opportunities. We help students
            find the right universities, programs, and resources for their
            academic journey.
          </p>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/vaibhavtyagi2000/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              onClick={() =>
                handleExternalLinkClick(
                  "https://www.facebook.com/vaibhavtyagi2000/"
                )
              }
            >
              <i className="social-icon facebook"></i>
            </a>
            <a
              href="https://x.com/vaibhavtyagi123"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
              onClick={() =>
                handleExternalLinkClick("https://x.com/vaibhavtyagi123")
              }
            >
              <i className="social-icon twitter"></i>
            </a>
            <a
              href="https://www.instagram.com/vaibhavtyagi2024/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              onClick={() =>
                handleExternalLinkClick(
                  "https://www.instagram.com/vaibhavtyagi2024/"
                )
              }
            >
              <i className="social-icon instagram"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/vaibhavtyagi2024/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              onClick={() =>
                handleExternalLinkClick(
                  "https://www.linkedin.com/in/vaibhavtyagi2024/"
                )
              }
            >
              <i className="social-icon linkedin"></i>
            </a>
            <a
              href="https://www.youtube.com/@vaibhavtyagi2024"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              onClick={() =>
                handleExternalLinkClick(
                  "https://www.youtube.com/@vaibhavtyagi2024"
                )
              }
            >
              <i className="social-icon youtube"></i>
            </a>
          </div>
        </div>

        <div className="footer-links-container">
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/blogs" onClick={() => handleLinkClick("/blogs")}>
                  Blogs
                </Link>
              </li>
              <li>
                <a
                  href="https://shorturl.at/uvKtH"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    handleExternalLinkClick("https://shorturl.at/uvKtH")
                  }
                >
                  Free Counseling
                </a>
              </li>
              <li>
                <button
                  className="footer-link-button"
                  onClick={handleAdmissionPredictorClick}
                >
                  Admission Predictor
                </button>
              </li>
              <li>
                <a
                  href="https://shorturl.at/uvKtH"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    handleExternalLinkClick("https://shorturl.at/uvKtH")
                  }
                >
                  Visa Guidance
                </a>
              </li>
              {/* <li>
                <Link
                  to="/university-rankings"
                  onClick={() => handleLinkClick("/university-rankings")}
                >
                  University Rankings
                </Link>
              </li> */}
            </ul>
          </div>
          <div className="footer-section">
            <h4>Popular Courses</h4>
            <ul>
              <li>
                <Link
                  to="/popular-courses"
                  onClick={() => handleLinkClick("/popular-courses")}
                >
                  View All Courses
                </Link>
              </li>
              <li>
                <Link
                  to="/popular-courses"
                  onClick={() => handleLinkClick("/popular-courses")}
                >
                  MS in Computer Science
                </Link>
              </li>
              <li>
                <Link
                  to="/popular-courses"
                  onClick={() => handleLinkClick("/popular-courses")}
                >
                  MBA
                </Link>
              </li>
              <li>
                <Link
                  to="/popular-courses"
                  onClick={() => handleLinkClick("/popular-courses")}
                >
                  MS in Mechanical Engineering
                </Link>
              </li>
              <li>
                <Link
                  to="/popular-courses"
                  onClick={() => handleLinkClick("/popular-courses")}
                >
                  MS in Civil Engineering
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li>
                <Link
                  to="/about-us"
                  onClick={() => handleLinkClick("/about-us")}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  onClick={() => handleLinkClick("/contact-us")}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>© {currentYear} Grad4Grad. All rights reserved.</p>
          {/* <div className="footer-bottom-links">
            <Link to="/sitemap" onClick={() => handleLinkClick("/sitemap")}>
              Sitemap
            </Link>
            <Link to="/privacy" onClick={() => handleLinkClick("/privacy")}>
              Privacy
            </Link>
            <Link to="/terms" onClick={() => handleLinkClick("/terms")}>
              Terms
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
